<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>

<nb-card>
  <nb-card-header>{{ user ? "Modifier un utilisateur" : "Ajouter un utilisateur" }}</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-sm-12">
        <div class="form">
          <form [formGroup]="editForm">
            <!-- Email (first field) -->
            <div class="form-group">
              <label>E-mail *</label>
              <input
                type="email"
                class="form-control"
                formControlName="email"
                (blur)="onEmailBlur()"
                [attr.disabled]="user ? true : null"
                />
              @if (checkingEmail) {
                <nb-spinner size="tiny"></nb-spinner>
              }
              @if (!emailChecked && !user && !checkingEmail) {
                <p class="text-muted mt-1">
                  <small
                    >Veuillez saisir l'email afin de vérifier si cette personne existe déjà</small
                    >
                  </p>
                }
                @if (emailExists && !user && !isQwintalAdmin) {
                  <p class="text-info mt-1">
                    <small>Cet utilisateur existe déjà et sera ajouté à cette exploitation</small>
                  </p>
                }
              </div>

              <!-- Firstname -->
              <div class="form-group">
                <label>Prénom *</label>
                <input type="text" class="form-control" formControlName="firstname" />
              </div>

              <!-- Lastname -->
              <div class="form-group">
                <label>Nom *</label>
                <input type="text" class="form-control" formControlName="lastname" />
              </div>

              <!-- Phone -->
              <div class="form-group">
                <label>Téléphone</label>
                <input type="text" class="form-control" formControlName="phone" />
              </div>

              <!-- Animal Types Selection -->
              <div class="form-group">
                <label>Types d'animaux *</label>
                @if (loadingAnimalTypes) {
                  <nb-spinner size="tiny"></nb-spinner>
                }

                @if (!loadingAnimalTypes && availableAnimalTypes.length > 0) {
                  <nb-select
                    fullWidth
                    multiple
                    formControlName="animalTypeIds"
                    placeholder="Sélectionnez les types d'animaux"
                    >
                    @for (animalType of availableAnimalTypes; track animalType) {
                      <nb-option [value]="animalType.id">
                        {{ animalType.label }}
                      </nb-option>
                    }
                  </nb-select>
                }

                @if (!loadingAnimalTypes && availableAnimalTypes.length > 0) {
                  <p
                    class="text-muted mt-1"
                    >
                    <small>Sélectionnez les types auxquels cet utilisateur aura accès</small>
                  </p>
                }

                @if (!loadingAnimalTypes && availableAnimalTypes.length === 0) {
                  <nb-alert
                    status="warning"
                    >
                    Cette entreprise n'a aucun type d'animal configuré.
                  </nb-alert>
                }

                @if (
                  editForm.get('animalTypeIds')?.hasError('atLeastOneRequired') &&
                  editForm.get('animalTypeIds')?.touched
                  ) {
                  <nb-alert
                    status="danger"
                    >
                    Vous devez sélectionner au moins un type d'animal
                  </nb-alert>
                }
              </div>

              <!-- Multi-company warning -->
              @if (user && isMultiCompanyUser && !authService.getUser()?.isAdmin) {
                <div
                  class="form-group"
                  >
                  <nb-alert status="info">
                    Cet utilisateur est lié à plusieurs comptes. Seuls les administrateurs peuvent
                    modifier ses informations personnelles.
                  </nb-alert>
                </div>
              }

              <!-- Role management for ADMIN context -->
              @if (context === 'admin' && (!user || user.isInternalRole())) {
                <div class="form-group">
                  <input
                    type="checkbox"
                    class="mr-2"
                    formControlName="isBreederAdmin"
                    id="isBreederAdmin"
                    (change)="onBreederAdminCheckboxChange()"
                    />
                  <label for="isBreederAdmin">Utilisateur administrateur du compte client</label>
                </div>
              }

              <!-- External role: BREEDERADMIN context, or ADMIN context when creating -->
              @if (canChooseExternalRole) {
                <div>
                  <div class="form-group">
                    <input
                      type="checkbox"
                      class="mr-2"
                      formControlName="isExternal"
                      id="isExternal"
                      (change)="onExternalCheckboxChange()"
                      />
                    <label for="isExternal">Utilisateur externe</label>
                    <p class="text-muted mt-1">
                      <small
                        >Cochez cette case pour inviter un utilisateur externe (technicien coopérative,
                        vétérinaire...)</small
                        ><br />
                        <small class="text-danger"
                          >Un utilisateur externe ne pourra pas modifier
                          {{ context === "admin" ? "les données de l'exploitation" : "vos données" }}</small
                          >
                        </p>
                      </div>
                      @if (editForm.get('isExternal')?.value) {
                        <div class="form-group">
                          <label>Rôle *</label>
                          <nb-select
                            fullWidth
                            formControlName="externalRole"
                            placeholder="Sélectionnez un rôle"
                            >
                            @for (role of externalRoles; track role) {
                              <nb-option [value]="role">
                                {{ role | roleLabel }}
                              </nb-option>
                            }
                          </nb-select>
                        </div>
                      }
                    </div>
                  }

                  <!-- Info message for new users -->
                  @if (!user) {
                    <div class="form-group">
                      <p class="text-muted">
                        <small
                          >Un e-mail invitant l'utilisateur à
                          {{ emailExists ? "rejoindre cette exploitation" : "créer un mot de passe" }} sera
                          automatiquement envoyé.</small
                          >
                        </p>
                      </div>
                    }

                    <!-- Error message -->
                    @if (errorMessage) {
                      <div class="form-group">
                        <nb-alert status="danger">{{ errorMessage }}</nb-alert>
                      </div>
                    }
                  </form>
                </div>
              </div>
            </div>
          </nb-card-body>
          <nb-card-footer>
            <button
              nbButton
              fullWidth
              status="primary"
              shape="round"
              (click)="saveAction()"
      [disabled]="
        !editForm.valid ||
        loading ||
        checkingEmail ||
        (!user && !emailChecked) ||
        loadingAnimalTypes ||
        availableAnimalTypes.length === 0
      "
              >
              @if (loading) {
                <nb-spinner size="small" status="basic"></nb-spinner>
              }
              @if (!loading) {
                <span>{{ user ? "Enregistrer" : "Ajouter" }}</span>
              }
            </button>
          </nb-card-footer>
        </nb-card>
